import { gql } from '@apollo/client';



export const GET_USERNAME_BY_EMAIL = gql`
  query($email: String!){
    user_account(where: {email: {_eq: $email}}) {
      username
    }
  }
`;


export const GET_USER_ACCOUNT = gql`
query($email: String, $username: String) {
  user_account(where: {_or: [{email: {_eq: $email}},{username: {_eq: $username}}]}) {
    email
    membership{
      type
      name
      price
    }
    payment_complete
    red_flag
    username
    verified
    due_date
    stripe_customer_id 
    preferences:user_preferences{
      category {
        name
        id
      }    
    }
    user_data {
      about
      avatar
      email
      pronouns
      medical_school
      name
      looking_for
      can_offer
      class_status
      admitted_year
      applicant_replicant
      specialties
      username
      career
      calendar_url
    }

  }
}
`;

export const RESOURCES = gql`
  query Resources($limit: Int, $offset: Int, $categories: [String]) {
    resources(limit: $limit, offset: $offset, categories: $categories) {
      id
      tags
      categories
      description
      link
      name
      picture_name
      rating
      price_from
      price_to
      reviewsCount
    }
  }
`;


export const RESOURCE_DETAIL = gql`
  query Resource($id: String!) {
    resource(id: $id) {
      categories
      description
      id
      link
      name
      picture_name
      rating
      tags
      reviewsCount
      stars_1
      stars_2
      stars_3
      stars_4
      stars_5
    }
  }
`;


export const UNVALIDATE_USERS = gql`
  query UnvalidatedUser {
    user_account(where: { verified: { _eq: false } }) {
      email
      name
      last_name
      medical_school
      class_status
      verification_file
    }
  }
`;

export const USERS_QUERY_PG = gql`
  query UsersPG {
    user_data {
      avatar
      username
      email
      about
      name
      career
      medical_school
      class_status
      specialties
      can_offer
      looking_for
      applicant_replicant
      user_account {
        membership_type
      }
    }
  }
`;
export const USERS_QUERY_PG_USERNAME = gql`
  query UsersPGUsername($like: String!) {
    user_account(
      where: { username: { _similar: $like }, verified: { _eq: true } }
    ) {
      username
    }
  }
`;

export const GET_LOCKER = gql`
  query GetLocker($email: String!) {
    resources_locker(where: { user_id: { _eq: $email } }) {
      resource_id
    }
  }
`;

export const GET_RESOURCE_COMMENTS = gql`
  query GetResourceComments($id: String!, $limit: Int, $offset: Int) {
    resourceComments(docId: $id, limit: $limit, offset: $offset) {
      comment
      createdAt
      id
      rating
      specialties
      subjects
      title
      usedInTests
      username
      replies {
        comment
        username
      }
    }
  }
`;

export const GET_RESOURCE_PERCENTAGE = gql`
  query GetResourcePercentage($resourceId: String!) {
    resourceUsePercent(resourceId: $resourceId) {
      percentage
    }
  }
`;

export const GET_HELPFUL_REVIEWS = gql`
  query GetHelpfulReviews($resourceId: String!, $userId: String!) {
    helpful_review(
      where: { resource_id: { _eq: $resourceId }, user_id: { _eq: $userId } }
    ) {
      resource_review_id
    }
  }
`;

export const GET_SPECIALTIES = gql`
  query GetSpecialties {
    medical_specialties {
      specialties_name
      id
    }
  }
`;

export const GET_REVIEWS_BY_USER = gql`
  query GetReviewsByUser($userId: String!) {
    users_reviews(where: { user_id: { _eq: $userId } }) {
      resource_id
      userReviewResource {
        name
        picture_name
      }
      ReviewComment {
        title
        comment
        rating
      }
    }
  }
`;

export const GET_LOCKER_RESOURCES_BY_USER = gql`
  query GetLockerResourceByUser($userId: String!) {
    resources_locker(where: { user_id: { _eq: $userId } }) {
      resource_id
      resource_locker {
        picture_name
        name
        rating
      }
    }
  }
`;

export const GET_SCHOOLS = gql`
  query GetSchools {
    school_programs {
      school_name
    }
  }
`;
export const GET_USERNAMES = gql`
  query usernames {
    user_account{
      username
    }
  }
`;

export const EMAIL_USERNAME_VERIFICATION = gql`
  query($email: String, $username: String!) {
    user_account(
      where: {
        _or: [{ email: { _eq: $email } }, { username: { _eq: $username } }]
      }
    ) {
      email
    }
  }
`;

export const GET_DISCIPLINES = gql`
  query GetDisciplines {
    medical_diciplines {
      dicipline_name
    }
  }
`;

export const GET_HELPFUL_COUNT = gql`
  query GetHelpfulReview($resource_review_id: String!) {
    helpful_review(
      where: { resource_review_id: { _eq: $resource_review_id }, user_id: {} }
    ) {
      user_id
    }
  }
`;


export const GET_NEWS = gql`
  query($searchText: String, $offset: Int, $category: String, $audience: String, $mediaType: String){
    articles (
    limit: 10, 
    offset: $offset, 
    order_by: {created_at: desc}, 
    where: {_and: [
      {_or: [
        {title: {_ilike: $searchText}}, 
        {description: {_ilike: $searchText}}
      ]},
      {categories: {category: {name: {_ilike: $category}}}},
      {audiences: {audience: {name: {_ilike: $audience}}}},
      {media_types: {media_type: {name: {_ilike: $mediaType}}}}
    ]}) {
      id
      description
      website_link
      title
      publisher_email
      image_key
      created_at
      audiences {
        audience {
          id
          name
        }
      }
      categories {
        category {
          id
          name
        }
      }
      media_types {
        media_type {
          id
          name
        }
      }
    }
  }
`;

export const CONNECTED_USERS = gql`
  query ($username: jsonb!) {
    users_connection(where: {usernames: {_contains: $username}}, order_by: {score: desc}) {
      id
      usernames
      status
      sender
    }
  }
`;

export const GET_ROCKET_UNREAD_NOTIFICATIONS = gql`
  query($email:String!){
    getRocketUnreadNotifications(email: $email) {
      result
    }
  }
`;


export const RETRIEVE_STRIPE_CUSTOMER = gql`
  query($customerId:String){
    retrieveStripeCustomer(customerId: $customerId) {
      result
    }
  }
`;

export const GET_RESOURCE_NAME_ID = gql`
  query {
    resources{
      id
      name
    }
  }
`;

export const GET_CUSTOM_TOKEN_BY_UID = gql`
  query($uid:String!){
    getAuthTokenByUid(uid: $uid) {
      token
    }
  }
`;